import { gql, useQuery } from '@apollo/client';

const GET_ENTERPRISE_CLIENT = gql`
  query GetEnterpriseInfo($id: String!) {
    enterpriseInfo: getEnterprise(id: $id) {
      id
      name
      email
      cnpj
      phone
      addressFull {
        address
        number
        neighborhood
        city
        state
      }
    }
  }
`;

export interface GetEnterpriseInfo {
  enterpriseInfo: {
    id: string;
    name: string;
    email: string;
    cnpj: string;
    phone: string;
    addressFull: {
      address: string;
      number: string;
      neighborhood: string;
      city: string;
      state: string;
    };
  };
}

interface Variables {
  enterpriseId: number;
}

export function useEnterpriseInfo({ enterpriseId }: Variables) {
  return useQuery(GET_ENTERPRISE_CLIENT, { 
    variables: { id: String(enterpriseId) },
    context: {
      uri: process.env.REACT_APP_VISTORIA_SYNC_GRAPHQL,
    },
  });
}
